<template> <!-- OK -->
    <div>
        <Navbar/>
        <div class="pagina-resultados-container">
            <div v-if="isLoading" class="loading-container">
                <div class="spinner"></div>
                <p>Carregando...</p>
            </div>
            <UpdateResultsAdmin v-else-if="isAdmin" />
            <UpdateResults v-else/>
        </div>
    </div>
</template>


<script>

    import Navbar from '../components/NavBar.vue';
    import UpdateResults from '../components/UpdateResults.vue';
    import UpdateResultsAdmin from '@/components/UpdateResultsAdmin.vue';
    import userService from '@/services/userService';

    export default {
        name: 'Resultados',
        components: {
            Navbar,
            UpdateResults,
            UpdateResultsAdmin
        },
        data(){
            return {
                isAdmin: false,
                isLoading: true,
            };
        },
        async created(){
            try{
                const response = await userService.getUserInfo();
                this.isAdmin = response.data.isAdmin;
            } catch(error){
                console.error('Erro ao buscar informações do usuário', error);
            } finally {
                this.isLoading = false;
            }
        },
        
    };

</script>

<style scoped>

    .pagina-resultados-container{
        background-color: #003366;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2rem 0;
    }

    .loading-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .loading-container p {
        margin-top: 1rem;
        font-size: 1.5rem;
        color: white;
    }

    .spinner{
        width: 50px;
        height: 50px;
        border: 6px solid #f3f3f3;
        border-top: 6px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @media (max-width: 425px){
        .pagina-resultados-container{
            padding: 1rem 0;
        }

        .loading-container p {
            font-size: 1.2rem;
        }

        .spinner{
            width: 40px;
            height: 40px;
            border-width: 5px;
        }
    }

</style>